<template>
    <div>
        <Panel
            :title="$t('Recording Retention Periods')"
            :add-button="$store.hasRight('ADD_RETENTION_RULES') ? $t('Add') : ''"
            :delete-button="$store.hasRight('DELETE_RETENTION_RULES') && selected.length > 0"
            @delete="handleDelete"
            @input="openForm(-1)"
        >
            <table id="retentionperiods_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Period name') }}</th>
                        <th>{{ $t('Duration') }}</th>
                        <th v-if="$store.hasRight('DELETE_RETENTION_RULES')" class="td-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="period in items" @click="(evt) => handleOpen(period.periodId, evt)">
                        <td class="primary">
                            {{ period.name }}
                        </td>
                        <td>{{ formatDuration(period.duration) }}</td>
                        <td v-if="$store.hasRight('DELETE_RETENTION_RULES')">
                            <cic-checkbox
                                :value="selected.includes(period.periodId)"
                                @click="handleSelected(period.periodId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <EditRetentionPeriod
            v-if="item !== null && !$store.showLoadingOverlay"
            :item="item"
            @blur="closePopup"
            @input="saveItem"
            @updateFieldValue="updateFieldValue"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import TableUtils from '@/mixins/TableUtils';
    import { deleteItems, load, save } from '@/utils/Http';
    import { showValidationMessage } from '@/utils/Notification';
    import EditRetentionPeriod from './EditRetentionPeriod';

    export default {
        name: 'RetentionPeriods',
        components: {
            Panel,
            EditRetentionPeriod,
            CicCheckbox,
        },
        mixins: [TableUtils],
        emits: ['change'],
        data() {
            return {
                item: null,
                items: [],
                selected: [],
            };
        },
        created() {
            this.loadTable();
        },
        methods: {
            handleDelete() {
                deleteItems('retentionperiods/delete', { periodIds: this.selected }, this.loadTable);
            },

            formatDuration(duration) {
                let value = duration / 60;
                let units = 'minute';
                if (value % 60 === 0) {
                    value = value / 60;
                    units = 'hour';
                    if (value % 24 === 0) {
                        value = value / 24;
                        units = 'day';
                        if (value % 365 === 0) {
                            value = value / 365;
                            units = 'year';
                        }
                    }
                }

                return this.$t(value === 1 ? `1 ${units}` : `[x] ${units}s`).replace(/\[x]/g, value.toString());
            },

            loadTable() {
                this.selected = [];
                this.closePopup();
                load('retentionperiods/get', {}, (response) => {
                    this.items = response.periods;
                    this.$emit('change', this.items);
                });
            },

            openForm(periodId) {
                if (periodId > 0) {
                    this.item = { ...this.items.find((x) => x.periodId === periodId) };
                } else {
                    this.item = {
                        periodId: null,
                        name: '',
                        duration: 0,
                    };
                }
            },

            saveItem() {
                if (!this.item.name || this.item.name.trim() === '') {
                    showValidationMessage('Period name is a required field');
                    return;
                }

                if (!this.item.duration || this.item.duration === 0) {
                    showValidationMessage('Invalid Duration');
                    return;
                }

                save('retentionperiod/update', this.item, this.loadTable);
            },
        },
    };
</script>
